import { GlobalDialogState } from './global-dialog-selectors';

import type { Action } from './utils/state-manager';

const InitialState: GlobalDialogState = {
  openDialogs: {},
};

export default (state = InitialState, action: Action) => {
  switch (action.type) {
    case 'OPEN_GLOBAL_DIALOG': {
      if (!action.payload) {
        return state;
      }
      const { key, context } = action.payload;
      const openDialogs = {
        ...state.openDialogs,
        [key]: {
          context,
        },
      };
      return { ...state, openDialogs };
    }
    case 'CLOSE_GLOBAL_DIALOG': {
      if (!action.payload) {
        return state;
      }
      const { key } = action.payload;
      if (!state.openDialogs[key]) {
        return state;
      }
      const openDialogs = { ...state.openDialogs };
      delete openDialogs[key];
      return { ...state, openDialogs };
    }
    default:
      return state;
  }
};
